// 西班牙语
export const GUIDES = [
  { name: 'guide-overview', title: 'Resumen de funciones', groupIndex: 0 },
  { name: 'guide-account', title: 'Acerca de la cuenta', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Sobre el vehículo', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Cómo configurar el salpicadero', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Cómo Cómo configurar el vehículoel salpicadero', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Cómo navegar para encontrar el vehículo', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Cómo utilizar la navegación', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Sobre el historial de conducción', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Cómo realizar una autoinspección del vehículo', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Cómo hacer la configuración general de la aplicación', groupIndex: 3 },
  { name: 'guide-notice', title: 'Cómo ver y configurar la notificación de mensajes', groupIndex: 3 },
  { name: 'guide-about', title: 'Acerca de la aplicación', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'Pendiente',
  1: 'No responde',
  2: 'Replied',
  3: 'en comunicación',
  4: 'contramedidas',
  5: 'resuelto',
};

export const FEEDBACK_TYPES = {
  1: 'Comentarios',
  2: 'Respuesta',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
